"use client"
import React, { Fragment } from "react"
import { Icon } from '@iconify/react';

import { Card } from "@/components/ui/custom/ui/card"
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/custom/ui/table"
import { ScrollArea, ScrollBar } from "@/components/ui/custom/ui/scroll-area";

import {
  flexRender,
  getCoreRowModel,
  getFacetedRowModel,
  getFacetedUniqueValues,
  getFilteredRowModel,
  getPaginationRowModel,
  getSortedRowModel,
  useReactTable
} from "@tanstack/react-table";

const DataTableClient = ({
  currentUser,
  data,
  columnDef,
  sortRef
}) => {
  // console.log(data)
  const table = useReactTable({
    columns: columnDef,
    data: data?.diff || [],
    initialState: {
      pagination: {
        pageIndex: 0,
        pageSize: 10
      },
      // sorting: [
      //   {
      //     id: sortRef,
      //     desc: true
      //   }
      // ]
    },
    getCoreRowModel: getCoreRowModel(),
    getFilteredRowModel: getFilteredRowModel(),
    getPaginationRowModel: getPaginationRowModel(),
    getSortedRowModel: getSortedRowModel(),
    getFacetedRowModel: getFacetedRowModel(),
    getFacetedUniqueValues: getFacetedUniqueValues(),
  })

  console.log(currentUser)
  return (
    <Fragment>
      <ScrollArea className="w-full whitespace-nowrap rounded-md border overflow-auto bg-[metaxseed-black]/70 border-gray-700">
        <Table>
          <TableHeader>
            {table.getHeaderGroups().map((headerGroup) => (
              <TableRow key={headerGroup.id} className="border-b-gray-700">
                {headerGroup.headers.map((header) => (
                  <TableHead key={header.id} className="text-gray-200 gothamMedium text-xs whitespace-nowrap justify-center">
                    {flexRender(
                      header.column.columnDef.header,
                      header.getContext()
                    )}
                  </TableHead>
                ))}
              </TableRow>
            ))}
          </TableHeader>
          <TableBody>
            {table.getRowModel().rows?.length ? (
              table.getRowModel().rows.map((row) => (
                <>
                  {/* {currentUser && (
                    <TableRow className="bg-metaxseed-black/90 text-white rounded-md border-b-2 border-metaxseed-blue">
                      {columnDef.map((column) => (
                        <td
                          key={column.id}
                          className="px-4 py-2 gotham text-sm border-b border-gray-700 whitespace-nowrap"
                        >
                          <div className={`flex items-center ${column.id === 'user' ? 'justify-start' : 'justify-center'}`}>
                            {column.cell ? column.cell({ row: { original: currentUser } }) : currentUser[column.id]}
                          </div>
                        </td>
                      ))}
                    </TableRow>
                  )} */}

                  <TableRow key={row.id}
                    className="bg-metaxseed-black text-white rounded-md"
                    style={{ paddingBottom: "10px" }}
                  >
                    {row.getVisibleCells().map((cell) => (
                      <td
                        key={cell.id}
                        onClick={() => console.log('Column ID:', cell.column.id)}
                        className="px-4 py-2 gotham text-sm border-b border-gray-700 whitespace-nowrap"
                      >
                        <div className={`flex items-center ${cell.column.id === 'user' ? 'justify-start' : 'justify-center'}`}>
                          {flexRender(cell.column.columnDef.cell, cell.getContext())}
                        </div>
                      </td>
                    ))}
                  </TableRow>
                </>
              ))
            ) : (
              <tr>
                <td colSpan={columnDef.length} className="text-center h-24">No data</td>
              </tr>
            )}
          </TableBody>
        </Table>
        <ScrollBar orientation="horizontal" />
      </ScrollArea>
      <div className="flex gap-2 justify-between items-stretch w-full mt-4">
        <button
          className={`text-white rounded-md py-1 px-4 flex justify-center w-40 ${!table.getCanPreviousPage() ? 'bg-metaxseed-gray' : 'bg-metaxseed-blue'}`}
          onClick={() => table.previousPage()}
          disabled={!table.getCanPreviousPage()}
        >
          <Icon icon="ph:caret-left-bold" className="text-xl" />
        </button>

        <button
          className={`text-white rounded-md py-1 px-4 flex justify-center w-40 ${!table.getCanNextPage() ? 'bg-metaxseed-gray' : 'bg-metaxseed-blue'}`}
          onClick={() => table.nextPage()}
          disabled={!table.getCanNextPage()}>
          <Icon icon="ph:caret-right-bold" className="text-xl" />
        </button>
      </div>
    </Fragment>
  )
};

export default DataTableClient;
